// Identity check against the fleet eKYC service (document + liveness + face match).
// The server opens the session and reads the result; the browser only shows the provider's page
// and asks the server whether it has passed.

const POLL_MS = 3000;
const GIVE_UP_MS = 12 * 60 * 1000;

/**
 * Returns { provider: 'simulated' } when the server has no eKYC provider configured,
 * otherwise opens a session and resolves { provider: 'ekyc', url }.
 */
export async function startKyc(api) {
  const res = await api.post('/kyc/start');
  return res.data;
}

/**
 * Polls the server until the check passes, fails or expires.
 * `isCancelled()` stops the loop (modal closed / retry started).
 * Resolves 'verified' | 'failed' | 'expired' | 'cancelled'; throws on a 4xx/5xx other than a transient 503.
 */
export async function waitForKyc(api, isCancelled) {
  const t0 = Date.now();
  while (!isCancelled()) {
    await new Promise((r) => setTimeout(r, POLL_MS));
    if (isCancelled()) break;
    if (Date.now() - t0 > GIVE_UP_MS) return 'expired';
    try {
      const { data } = await api.post('/kyc/verify');
      if (data.status === 'verified') return 'verified';
      if (data.status === 'failed') return { status: 'failed', message: data.message };
      if (data.status === 'expired' || data.status === 'none') return 'expired';
    } catch (err) {
      if (err.response?.status !== 503) throw err;
    }
  }
  return 'cancelled';
}
